<template>
  <div class="overflow-y-scroll">
    <!--    <h3>{{ panelTitle }}</h3>-->
    <section>
      <div class="form-inline flex-row">
        <label>Title:</label>
        <div>
          <input type="text" placeholder="Title" v-model="editTitle" />
        </div>
      </div>
      <div class="form-inline flex-row">
        <label>Hours per week:</label>
        <div>
          <input type="text" placeholder="Hours per week" v-model="editHours" />
        </div>
      </div>
      <div class="form-inline flex-row">
        <label>Rate type:</label>
        <div>
          <model-select
            :options="rateTypeOptions"
            v-model="editRateType"
            placeholder="Rate Type"
          ></model-select>
        </div>
      </div>
      <div class="form-inline flex-row">
        <label>Rate:</label>
        <div>
          <input type="text" placeholder="Rate" v-model="editRateToClient" />
        </div>
      </div>
      <div class="form-inline">
        <label>Requirements and Skills:</label>
        <div>
          <quill-editor
            name="Requirements and Skills"
            :options="editorOption"
            :content="editRequirements"
            v-model="editRequirements"
          />
        </div>
      </div>
      <div class="form-inline">
        <label>Tech Level:</label>
        <div>
          <multi-select
            :options="techLevelOptions"
            :selected-options="editTechLevel"
            @select="onSelectTechLevel"
            placeholder="Tech Level"
          ></multi-select>
        </div>
      </div>
      <div class="form-inline flex-row">
        <label>Location:</label>
        <div>
          <model-select
            :options="metroOptions"
            v-model="editLocation"
            placeholder="Location"
          ></model-select>
        </div>
      </div>
      <div class="form-inline flex-row">
        <label>Work Type:</label>
        <div>
          <model-select
            :options="roleWorkTypeOptions"
            v-model="editWorkType"
            placeholder="Work Type"
          ></model-select>
        </div>
      </div>
      <div class="form-inline">
        <label>Tech Work Type:</label>
        <div>
          <multi-select
            :options="techWorkTypeOptions"
            :selected-options="editTechWorkType"
            @select="onSelectTechWorkType"
            placeholder="Tech Work Type"
          ></multi-select>
        </div>
      </div>
      <div class="form-inline flex-row">
        <label>Engagement Length:</label>
        <div>
          <input
            type="text"
            placeholder="Engagement"
            v-model="editEngagement"
          />
        </div>
      </div>
      <div class="form-inline flex-row">
        <label for="startTime">Estimated Start</label>
        <VueCtkDateTimePicker
          id="start"
          v-model="editEstimatedStart"
          :right="true"
          :no-label="false"
          :no-value-to-custom-elem="true"
          format="YYYY-MM-DD HH:mm"
          formatted="llll"
        >
          <input
            type="text"
            id="startTime"
            :value="editEstimatedStart"
            placeholder="select date"
          />
        </VueCtkDateTimePicker>
      </div>
      <div class="form-inline flex-row m-t-l">
        <spinnerButton
          class="submit primary"
          :loading="loading"
          @click.native="buttonClick"
          >{{ buttonName }}</spinnerButton
        >
      </div>
    </section>
  </div>
</template>

<script>
import spinnerButton from "@/components/public/SpinnerButton";
import * as database from "@/vendor/database";
import { randomString } from "@/utils/utils";
import { ModelSelect, MultiSelect } from "vue-search-select";
import VueCtkDateTimePicker from "vue-ctk-date-time-picker";
import "vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css";
import moment from "moment-timezone";

export default {
  props: [
    "propsData",
    "roleId",
    "techLevelOptions",
    "metroOptions",
    "techWorkTypeOptions",
  ],
  components: {
    spinnerButton,
    ModelSelect,
    VueCtkDateTimePicker,
    MultiSelect,
  },
  computed: {
    isEdit() {
      return this.roleId !== undefined && this.roleId !== null;
    },
  },
  data() {
    return {
      panelTitle: null,
      buttonName: null,
      loading: false,
      editId: null,
      editTitle: null,
      editHours: null,
      editRateToClient: null,
      editRequirements: null,
      editPublic: null,
      editRateType: null,
      editSMS: null,
      editAutosend: null,
      editTechLevel: [],
      rateTypeOptions: [
        { text: "hourly", value: "hourly" },
        { text: "monthly", value: "monthly" },
      ],
      editLocation: null,
      editEngagement: null,
      editEstimatedStart: null,
      roleWorkTypeOptions: [
        { text: "remote", value: "remote" },
        { text: "onsite", value: "onsite" },
      ],
      editWorkType: null,
      editTechWorkType: [],
      editorOption: {
        modules: {
          toolbar: [
            ["link", "bold", "italic", { list: "ordered" }, { list: "bullet" }],
          ],
        },
        theme: "snow",
      },
      limitRateOptions: [
        { text: "true", value: true },
        { text: "false", value: false },
      ],
      editLimitRate: null,
    };
  },
  created: function () {
    this.initData();
  },
  watch: {
    propsData: function () {
      this.initData();
    },
  },
  methods: {
    onSelectTechLevel(items) {
      this.editTechLevel = items;
    },
    onSelectTechWorkType(items) {
      this.editTechWorkType = items;
    },
    initData: function () {
      this.editId = this.propsData.id;
      this.roles = this.propsData.roles;
      if (
        this.roleId !== undefined &&
        this.roleId !== null &&
        this.roles[this.roleId]
      ) {
        this.panelTitle = "Edit Role";
        this.buttonName = "Edit Role";
        this.editTitle = this.roles[this.roleId].title;
        this.editHours = this.roles[this.roleId].hours_per_week;
        this.editRateToClient = this.roles[this.roleId].rate_to_client;
        this.editRequirements = this.roles[this.roleId].requirements;
        this.editRateType = this.roles[this.roleId].rate_type;
        this.editTechLevel = [];
        if (
          this.roles[this.roleId].tech_level &&
          this.roles[this.roleId].tech_level.split(",")
        ) {
          this.editTechLevel = this.roles[this.roleId].tech_level
            .split(",")
            .map((item) => ({
              text: item,
              value: item,
            }));
        }
        this.editLocation = this.roles[this.roleId].location;
        this.editEngagement = this.roles[this.roleId].engagement;
        this.editEstimatedStart = this.roles[this.roleId].estimated_start
          ? moment(this.roles[this.roleId].estimated_start * 1000).format(
              "YYYY-MM-DD HH:mm"
            )
          : null;
        this.editWorkType = this.roles[this.roleId].work_type;
        this.editTechWorkType = [];
        if (
          this.roles[this.roleId].tech_work_type &&
          this.roles[this.roleId].tech_work_type.split(",")
        ) {
          this.editTechWorkType = this.roles[this.roleId].tech_work_type
            .split(",")
            .map((item) => ({
              text: item,
              value: item,
            }));
        }
        this.editAutomatch = this.roles[this.roleId].automatch;
        this.editLimitRate = this.roles[this.roleId].limit_rate;
      } else {
        this.panelTitle = "Add Role";
        this.buttonName = "Add Role";
        this.editTitle = null;
        this.editHours = null;
        this.editRateToClient = null;
        this.editRequirements = null;
        this.editPublic = null;
        this.editRateType = null;
        this.editSMS = null;
        this.autosend = null;
        this.editTechLevel = [];
        this.editLocation = null;
        this.editEngagement = null;
        this.editEstimatedStart = null;
        this.editWorkType = null;
        this.editTechWorkType = [];
        this.editAutomatch = null;
        this.editLimitRate = null;
      }
    },
    buttonClick: async function () {
      const roles =
        this.roles && this.roles.length > 0
          ? JSON.parse(JSON.stringify(this.roles))
          : [];
      if (
        this.roleId !== undefined &&
        this.roleId !== null &&
        roles[this.roleId]
      ) {
        roles[this.roleId] = {
          id: roles[this.roleId].id,
          title: this.editTitle ? this.editTitle : null,
          hours_per_week: this.editHours ? this.editHours : null,
          rate_to_client: this.editRateToClient ? this.editRateToClient : null,
          requirements: this.editRequirements ? this.editRequirements : null,
          rate_type: this.editRateType ? this.editRateType : null,
          tech_level: this.editTechLevel
            ? this.editTechLevel.map((item) => item.value).join(",")
            : null,
          location: this.editLocation ? this.editLocation : null,
          engagement: this.editEngagement ? this.editEngagement : null,
          estimated_start: this.editEstimatedStart
            ? moment(this.editEstimatedStart, "YYYY-MM-DD HH:mm").valueOf() /
              1000
            : null,
          work_type: this.editWorkType ? this.editWorkType : null,
          tech_work_type: this.editTechWorkType
            ? this.editTechWorkType.map((item) => item.value).join(",")
            : null,
        };
      } else {
        roles.push({
          id: randomString(10),
          title: this.editTitle ? this.editTitle : null,
          hours_per_week: this.editHours ? this.editHours : null,
          rate_to_client: this.editRateToClient ? this.editRateToClient : null,
          requirements: this.editRequirements ? this.editRequirements : null,
          rate_type: this.editRateType ? this.editRateType : false,
          tech_level: this.editTechLevel
            ? this.editTechLevel.map((item) => item.value).join(",")
            : null,
          location: this.editLocation ? this.editLocation : null,
          engagement: this.editEngagement ? this.editEngagement : null,
          estimated_start: this.editEstimatedStart
            ? moment(this.editEstimatedStart, "YYYY-MM-DD HH:mm").valueOf() /
              1000
            : null,
          work_type: this.editWorkType ? this.editWorkType : null,
          tech_work_type: this.editTechWorkType
            ? this.editTechWorkType.map((item) => item.value).join(",")
            : null,
        });
      }
      try {
        this.loading = true;
        const result = await database.updateDocById("gigs", this.editId, {
          roles,
        });
        if (result.ok) {
          this.$toasted.global.toast_success({
            message: "success",
          });
          this.$emit("closePanel");
        } else {
          this.$toasted.global.toast_error({ message: "error" });
        }
        this.loading = false;
      } catch {
        this.$toasted.global.toast_error({ message: "error" });
        this.loading = false;
      }
    },
    onDelete: function () {
      this.$emit("deleteRole", this.roleId);
    },
  },
};
</script>
